import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';



import { RegisterService } from '../../../api/register/register.service';
import { BloguserService } from 'api/bloguser/bloguser.service';
import { totalmem } from 'os';
import { Title } from '@angular/platform-browser';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './bloguser.html',

})

export class Bloguser implements OnInit {



    isIconSelected: boolean = false;
    IconUrl: any;
    IconFile: File;
    firstname:string;
    lastname:string;
    email:string;
    mobile:any;
    password:any;
    sortdescription:any;
    facebooklink:any;
    youtubelink:any;
    githublink : any
    twitterlink:any;
    linkedinlink:any;
    pinterestlink:any;
    role:string
    bloguser=[]
    totaluser:number=0
    buser:any
    index:any;
    isactive:boolean
    file:File;
    blogerdesignation : string;


    constructor(private router: Router,

        private bloguserService: BloguserService ,private  titleService : Title) {
    }

    ngOnInit() {
        this.titleService.setTitle("Blog user  | Phoenix Games");
       this.role=localStorage.getItem('role')

       this.bloguserService.allbloguser().then(data => {

        if (data) {

            this.bloguser = data



           
            this.totaluser = this.bloguser.length;
        }
        else {

        }
    })

    }
    
    resetData() {
        this.email = "";
        this.password = "";
        this.firstname = "";
        this.lastname = "";
        this.mobile = "";
        this.blogerdesignation = "";
    }

    openUpdate(i, admin) {


        this.buser = admin;
        this.index = i;
        this.firstname = admin.firstname;
        this.lastname = admin.lastname;
        this.email = admin.email;
        this.isactive = admin.isactive;
        this.password = this.bloguserService.DescriptPassword(admin.password);
        this.mobile = admin.mobile;
        this.facebooklink=admin.facebooklink;
        this.youtubelink=admin.youtubelink;
        this.linkedinlink=admin.linkedinlink;
        this.twitterlink=admin.twitterlink;
        this.pinterestlink=admin.pinterestlink;
        // this.file=admin.profilepic;
        this.blogerdesignation = admin.bloggerdesignation;
        this.githublink = admin.githublink;
        

        
    
    }
    
    InsertUser() {
        if (this.firstname == undefined || this.firstname == "") {
            $.notify({
                message: "Please Enter First Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        else if (this.lastname == undefined || this.lastname == "") {
            $.notify({
                message: "Please Enter Last Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else if (this.email == undefined || this.email == "") {
            $.notify({
                message: "Please Enter Email."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        else if (this.mobile == undefined || this.mobile == "") {
            $.notify({
                message: "Please Enter Mobile."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else if (this.password == undefined || this.password == "") {
            $.notify({
                message: "Please Enter Password."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else if (this.blogerdesignation == undefined || this.blogerdesignation == "") {
            $.notify({
                message: "Please Enter Blogger Designation."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else {
            let registeruser =
            {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                password: this.password,
                mobile: this.mobile,
                facebooklink:this.facebooklink,
                youtubelink:this.youtubelink,
                linkedinlink:this.linkedinlink,
                twitterlink:this.twitterlink,
                pinterestlink:this.pinterestlink,
                bloggerdesignation : this.blogerdesignation,
                githublink : this.githublink

            }


            this.bloguserService.iblogger(registeruser).then(data => {


                if (data.status) {

                    this.totaluser++;
                    this.bloguser.push(data.data);
                    $(function () {
                        $('#adduser').modal('toggle');
                    });
                    this.resetData();
                    $.notify({
                        message: "Inserted Successfully"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });

                   
                    
                }
                else{
                    $.notify({
                        message: "Error In Insertion"
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                }


            });
        }
    }
    cancelAction() {
        this.firstname = "";
        this.mobile = "";
        this.password = "";
        this.email = "";
        this.lastname = "";
        this.facebooklink="";
        this.youtubelink=""
        this.linkedinlink="";
        this.twitterlink=""
        this.pinterestlink="";
        this.blogerdesignation= "";
        this.githublink = "";


    }
    UpdateUser() {
        if (this.firstname == undefined || this.firstname == "") {
            $.notify({
                message: "Please Enter First Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        else if (this.lastname == undefined || this.lastname == "") {
            $.notify({
                message: "Please Enter Last Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else if (this.email == undefined || this.email == "") {
            $.notify({
                message: "Please Enter Email."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        else if (this.mobile == undefined || this.mobile == "") {
            $.notify({
                message: "Please Enter Mobile."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else if (this.password == undefined || this.password == "") {
            $.notify({
                message: "Please Enter Password."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else if (this.blogerdesignation == undefined || this.blogerdesignation == "") {
            $.notify({
                message: "Please Enter Blogger Designation."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            return;
        }
        else {


           
            let registeruser =
            {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                password: this.password,
                mobile: this.mobile,
                // sortdescription:this.sortdescription,
                facebooklink:this.facebooklink,
                youtubelink:this.youtubelink,
                linkedinlink:this.linkedinlink,
                twitterlink:this.twitterlink,
                pinterestlink:this.pinterestlink,
                bloggerdesignation : this.blogerdesignation,
                githublink : this.githublink

            };


            
            this.bloguserService.ubloggers(this.buser.id,this.file, registeruser).then(data => {
                if (data) {
                    //   this.ToastMessage(data.message, data.status);
                    if (data.status) {
                        $.notify({
                            message: "Updated Successfully"
                        }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                        $(function () {
                            $('#updateuser').modal('toggle');
                        });
                        this.bloguser[this.index] = data.data;
                        this.cancelAction();
                    }
                    else {
                        $.notify({
                            message: "Error "
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                    }
                }

            });
        }
    }
    openDeactive(i, admin) {
        this.buser = admin;
        this.index = i;
        this.isactive = admin.isactive;
        // this.activeModal = this.dialogService.open(dialog);
    }

    DeactiveUser() {
        var _isactive ;
        if (this.isactive == true) {
            _isactive = 0;
        }
        else {
            _isactive = 1;
        }
        var aAdmin = {
            isactive: _isactive
        };

        this.bloguserService
            .dblogger(this.buser.id, aAdmin)
            .then(data => {
                if (data) {
                    //     this.ToastMessage(data.message, data.status);
                    if (data.status) {
                        this.bloguser[this.index].isactive = data.data.isactive;
                        $(function () {
                            $('#activedeactive').modal('toggle');
                        });

                    }
                }

            });
    }
    onlyNumberKey(event) {
        return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/bloguser/bloguser.page.ts